/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Snapchat browser pixel functions (free tier)
 *
 * Everything the Snap Pixel needs to load and fire browser events. The
 * Conversions API helpers (user data, click ID, server payload) live in
 * functions_premium.js.
 * */

(function (pmw, undefined) {

	// https://businesshelp.snapchat.com/s/article/pixel-direct-implementation
	//
	// Advanced Matching is a Pro setting and the user data is only in the
	// data layer on Pro, so this returns an empty object on free.
	pmw.snapchatGetUserInfo = () => {

		if (!pmwDataLayer?.pixels?.snapchat?.advanced_matching) {
			return {}
		}

		let userInfo = {}

		if (pmwDataLayer?.user?.email?.sha256) {
			userInfo.user_hashed_email = pmwDataLayer.user.email.sha256
		}

		if (pmwDataLayer?.user?.phone?.snapchat) {
			userInfo.user_hashed_phone_number = pmwDataLayer.user.phone.snapchat
		}

		if (pmwDataLayer?.user?.first_name?.raw) {
			userInfo.firstname = pmwDataLayer.user.first_name.raw
		}

		if (pmwDataLayer?.user?.last_name?.raw) {
			userInfo.lastname = pmwDataLayer.user.last_name.raw
		}

		if (pmwDataLayer?.user?.city?.raw) {
			userInfo.geo_city = pmwDataLayer.user.city.raw
		}

		if (pmwDataLayer?.user?.state?.raw) {
			userInfo.geo_region = pmwDataLayer.user.state.raw
		}

		if (pmwDataLayer?.user?.postcode?.raw) {
			userInfo.geo_postal_code = pmwDataLayer.user.postcode.raw
		}

		if (pmwDataLayer?.user?.country?.raw) {
			userInfo.geo_country = pmwDataLayer.user.country.raw
		}

		return userInfo
	}

	pmw.loadSnapchatPixel = () => {

		try {

			// @formatter:off
			(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
			{a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
				a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
				r.src=n;var u=t.getElementsByTagName(s)[0];
				u.parentNode.insertBefore(r,u);})(window,document,
				'https://sc-static.net/scevent.min.js');

			snaptr("init", pmwDataLayer.pixels.snapchat.pixel_id, pmw.snapchatGetUserInfo());
			// @formatter:on

			pmwDataLayer.pixels.snapchat.loaded = true;

		} catch (e) {
			console.error(e)
		}
	}

	pmw.getSnapchatOrderItemIds = () => {
		let contentIds = []

		Object.values(pmwDataLayer.order.items).forEach(item => {

			let product

			if (pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id) {
				product = pmwDataLayer.products[item.variation_id]
			} else {
				product = pmwDataLayer.products[item.id]
			}

			contentIds.push(pmw.getProductIdForSpecificPixel(product, "snapchat"))
		})

		return contentIds
	}

	/**
	 * Product custom data in the shape the adapter attaches to every
	 * product-level event. Pure product formatting, no user data.
	 */
	pmw.getSnapchatCustomDataForProduct = (product) => {
		return {
			content_category: product.category,
			content_ids     : [pmw.getProductIdForSpecificPixel(product, "snapchat")],
			content_name    : product.name,
			content_type    : "product",
			contents        : [{
				id        : pmw.getProductIdForSpecificPixel(product, "snapchat"),
				quantity  : product.quantity,
				item_price: product.price,
			}],
			currency        : pmw.getProductCurrency(product),
			num_items       : product.quantity,
			value           : product.price * product.quantity,
		}
	}

	/**
	 * Fire Snapchat event
	 *
	 * @return {boolean}
	 */
	pmw.canFireSnapchatEvent = () => {
		if (!pmwDataLayer?.pixels?.snapchat?.loaded) return false

		if (!pmw.consent.categories.get().marketing) return false

		return true
	}

	/**
	 * Can not fire Snapchat event
	 *
	 * @return {boolean}
	 */
	pmw.canNotFireSnapchatEvent = () => {
		return !pmw.canFireSnapchatEvent()
	}

}(window.pmw = window.pmw || {}));
